import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

const NotificationIcon: React.FC<IconProps> = (props) => (

<svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
<path d="M8.33333 17.8333H11.6667C11.6667 18.75 10.9167 19.5 10 19.5C9.08333 19.5 8.33333 18.75 8.33333 17.8333ZM17.5 16.1667V17H2.5V16.1667L4.16667 14.5V9.5C4.16667 6.91667 5.83333 4.66667 8.33333 3.91667V3.66667C8.33333 2.75 9.08333 2 10 2C10.9167 2 11.6667 2.75 11.6667 3.66667V3.91667C14.1667 4.66667 15.8333 6.91667 15.8333 9.5V14.5L17.5 16.1667ZM14.1667 9.5C14.1667 7.16667 12.3333 5.33333 10 5.33333C7.66667 5.33333 5.83333 7.16667 5.83333 9.5V15.3333H14.1667V9.5Z" fill="currentColor"/>
</svg>


);

export default NotificationIcon;


